/**
 * Categories Grid Animation with GSAP
 * Animações de entrada e efeitos interativos para o grid de categorias
 */

document.addEventListener('DOMContentLoaded', () => {
	const categoriesGrid = document.querySelector('[data-categories-grid]');
	if (!categoriesGrid) return;

	const cards = categoriesGrid.querySelectorAll('[data-category-card]');
	if (!cards.length) return;

	// Stagger animation on page load
	// gsap.from(cards, {
	// 	opacity: 0,
	// 	y: 40,
	// 	duration: 0.6,
	// 	stagger: 0.1,
	// 	ease: 'cubic.out',
	// 	overwrite: false
	// });

	// Add hover animations with GSAP
	cards.forEach((card) => {
		const image = card.querySelector('.category-card__image');
		const description = card.querySelector('.category-card__description');
		const meta = card.querySelector('.category-card__meta');

		card.addEventListener('mouseenter', () => {
			// Light blur effect
			if (image) {
				gsap.to(image, {
					filter: 'blur(2px)',
					duration: 0.3,
					ease: 'power2.out'
				});
			}

			// Stagger animation for content elements
			if (description) {
				gsap.to(description, {
					opacity: 1,
					y: 0,
					duration: 0.4,
					ease: 'cubic.out'
				});
			}

			if (meta) {
				gsap.to(meta, {
					opacity: 1,
					y: 0,
					duration: 0.4,
					delay: 0.1,
					ease: 'cubic.out'
				});
			}
		});

		card.addEventListener('mouseleave', () => {
			// Remove blur
			if (image) {
				gsap.to(image, {
					filter: 'blur(0px)',
					duration: 0.3,
					ease: 'power2.out'
				});
			}

			// Hide description and meta
			if (description) {
				gsap.to(description, {
					opacity: 0,
					y: 10,
					duration: 0.3,
					ease: 'power2.in'
				});
			}

			if (meta) {
				gsap.to(meta, {
					opacity: 0,
					y: 10,
					duration: 0.3,
					ease: 'power2.in'
				});
			}
		});
	});

	// Add scroll animation
	if (window.IntersectionObserver) {
		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					entry.target.style.opacity = '1';
				}
			});
		}, { threshold: 0.1 });

		cards.forEach((card) => {
			observer.observe(card);
		});
	}
});
